// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__2VCpL","form":"Form_form__31EpL","submit":"Form_submit__3eX9h"};